import { useMiscContentDetailsPageData } from 'src/app/pages/misc/pageContext';

type Result = ModelHookResult<{
	title: string;
}>;

export function usePageMeta(): Result {
	const {
		data: {
			details: { title },
		},
	} = useMiscContentDetailsPageData();

	return {
		data: {
			title,
		},
	};
}
